import { useMemo, useState } from 'react';

const LEG_AND_SQUAT_MODIFIERS = {
	5: 1.2,
	6: 1.242,
	7: 1.284,
	8: 1.326,
	9: 1.368,
	10: 1.41
};

const BENCH_AND_CHEST_MODIFIERS = {
	5: 1.15,
	6: 1.18,
	7: 1.22,
	8: 1.255,
	9: 1.29,
	10: 1.325
};

const getExerciseModifier = (exercise, reps) => {
	if (exercise === 'Squat' || exercise === 'Leg Press') {
		return LEG_AND_SQUAT_MODIFIERS[reps] || 0;
	}

	if (exercise === 'Bench Press' || exercise === 'Chest Press') {
		return BENCH_AND_CHEST_MODIFIERS[reps] || 0;
	}

	return 0;
};

export default function WeightTraining() {
	const [exercise, setExercise] = useState('Leg Press');
	const [weight, setWeight] = useState(100);
	const [reps, setReps] = useState(5);

	const estimatedOneRepMax = useMemo(() => {
		const modifier = getExerciseModifier(exercise, reps);
		return (parseFloat(weight) * modifier).toFixed(0);
	}, [exercise, weight, reps]);

	return (
		<div className="calc-container-scroller">
			<div className="calc-container-scroller-inner">
				<div className="left marginRight10 tool">
					<h4>Weight Training Load Calculator</h4>
					<div className="spc-m-b-1">
						<div id="ddlExercise">
							<span className="labelwidth90">Exercise:</span><br />
							<select
								name="menu_exercise"
								id="menu_exercise"
								value={exercise}
								onChange={(e) => setExercise(e.target.value)}
							>
								<option value="Leg Press">Leg Press</option>
								<option value="Squat">Squat</option>
								<option value="Bench Press">Bench Press</option>
								<option value="Chest Press">Chest Press</option>
							</select>
						</div>
						<br />
						<span>Weight Lifted (lbs):</span>
						<br />
						<input
							type="number"
							id="menu_weight"
							value={weight}
							onChange={(e) => setWeight(parseFloat(e.target.value || '0'))}
						/>
						<br />
						<br />
						<div id="ddlReps">
							<span>Number of reps completed:</span>
							<br />
							<select
								name="menu_reps"
								id="menu_reps"
								value={reps}
								onChange={(e) => setReps(parseInt(e.target.value, 10))}
							>
								<option value="5">5</option>
								<option value="6">6</option>
								<option value="7">7</option>
								<option value="8">8</option>
								<option value="9">9</option>
								<option value="10">10</option>
							</select>
						</div>
						<br />
						<span style={{ display: 'block', border: '1px solid black', padding: '5px', backgroundColor: 'lightgoldenrodyellow' }}>
							Your estimated 1RM is <b><span id="max_rep_result">{estimatedOneRepMax}</span>lbs</b> (+/- 5lbs)
						</span>
						<br />
					</div>
				</div>
			</div>
		</div>
	);
}
